import { render, staticRenderFns } from "./ForgotPasswordSended.vue?vue&type=template&id=3a44edca&scoped=true&"
import script from "./ForgotPasswordSended.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordSended.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordSended.vue?vue&type=style&index=0&id=3a44edca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a44edca",
  null
  
)

export default component.exports